/* eslint-disable import/prefer-default-export */
/* eslint-disable no-case-declarations */
import dayjs from 'dayjs';

import { ConversationLinesTypes } from '.';

export const addDateHeaders = (
  conversations: ConversationLinesTypes[],
  dateFormat: 'full' | 'short' | 'relative' = 'full'
) => {
  if (!Array.isArray(conversations) || conversations.length === 0) {
    return [];
  }

  return conversations.map((msg, index, array) => {
    const currentDate = dayjs(msg.createAt);
    const currentDayKey = currentDate.format('YYYY-MM-DD');

    // Previous message
    const prevMsg = index > 0 ? array[index - 1] : null;
    const prevDayKey = prevMsg ? dayjs(prevMsg.createAt).format('YYYY-MM-DD') : null;

    // Show date header if it's the first message OR day is different
    const showHeader = index === 0 || currentDayKey !== prevDayKey;

    let createAt: string | undefined;

    if (showHeader) {
      switch (dateFormat) {
        case 'full':
          createAt = currentDate.format('dddd, DD MMMM YYYY');
          break;
        case 'short':
          createAt = currentDate.format('DD/MM/YYYY');
          break;
      }
    }

    return {
      ...msg,
      createAt,
    };
  });
};
